import Who from "../components/who/who";
import Message from "../components/message/message";
import Increase from "../components/increase/icrease";
function Whopage(){
    return(
        <>
          <Who/>
      <Message/>
      <Increase/>
        </>
    )
}
export default Whopage